<div class="accordion" id="accordionExample" style="margin-top: -25px;">

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading5">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse5" aria-expanded="false" aria-controls="collapse5">
                Soort schenking
            </button>
        </h2>
        <div id="collapse5" class="accordion-collapse collapse" aria-labelledby="heading5"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Het soort schenking is datgene wat wordt geschonken: dit kan geld zijn, maar ook goederen,
                effecten of een recht (zoals vruchtgebruik). De waarde van het object op het moment van schenking
                bepaalt de hoogte van de schenkbelasting, waarbij de waarde in het economisch verkeer leidend is.
                <div class="space20"></div>

                We onderscheiden in de aangifte schenkbelasting de volgende objecten:
                <ul>
                    <li><b>Contanten:</b> Geldbedragen, fysiek of giraal, zijn de meest voorkomende vorm van schenking.
                        Waardering is gelijk aan het nominale bedrag.
                    </li>
                    <li><b>Effecten:</b> Aandelen, obligaties of beleggingsrekeningen. De waarde wordt bepaald op de
                        beurskoers of marktwaarde op de datum van schenking.
                    </li>
                    <li><b>Onroerende zaak:</b> Woningen of andere vastgoedobjecten. De waarde wordt vastgesteld op
                        basis van de WOZ-waarde of een taxatie.
                    </li>
                    <li><b>Onderneming:</b> Een schenking van een onderneming (bijv. een eenmanszaak of aandelen in een
                        BV). Hierop kunnen bedrijfsopvolgingsfaciliteiten van toepassing zijn.
                    </li>
                    <li><b>Periodieke uitkering:</b> Een recht op een vaste, herhaalde betaling, zoals een lijfrente. De
                        waarde wordt bepaald volgens rekenregels van de Belastingdienst.
                    </li>
                    <li><b>Schuldigerkenning:</b> De schenker erkent schriftelijk een schuld aan de begiftigde, vaak in
                        de vorm van een notariële akte. Dit wordt gezien als schenking op papier.
                    </li>
                    <li><b>Kwijtschelding:</b> Het (deels) afzien van een vordering op de begiftigde. De waarde van de
                        kwijtgescholden schuld wordt als schenking beschouwd.
                    </li>
                    <li><b>Roerende zaak:</b> Auto’s, sieraden, kunst, inboedel enz. De waarde moet worden vastgesteld
                        op basis van de marktwaarde op het moment van schenking.
                    </li>
                    <li><b>Vruchtgebruik:</b> Het recht om gebruik te maken van een goed dat eigendom blijft van een
                        ander. Zowel het vruchtgebruik als de blote eigendom kunnen afzonderlijk worden geschonken.
                    </li>
                    <li><b>Overig:</b> Andere rechten of bezittingen die waarde vertegenwoordigen, zoals auteursrechten
                        of vorderingen op derden. Waardering vindt plaats op economische waarde.
                    </li>
                </ul>

                <snelstart-ui-alert type="warning">
                    Je kunt in deze module van SnelStart Fiscaal - Schenkingsaangifte voor 1 soort schenking aangifte
                    doen. In geval van meerdere soorten schenking van dezelfde schenker voor dezelfde ontvanger dien
                    je dus 2 (of meer) afzonderlijker aangifte in te dienen.
                </snelstart-ui-alert>


            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading6">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse6" aria-expanded="false" aria-controls="collapse6">
                Meerdere schenkingen in hetzelfde jaar
            </button>
        </h2>
        <div id="collapse6" class="accordion-collapse collapse" aria-labelledby="heading6"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Wanneer iemand in één kalenderjaar meerdere keren een schenking ontvangt van dezelfde schenker,
                moeten deze bedragen bij elkaar worden opgeteld. Ook schenkingen van fiscale partners van de schenker
                worden samengevoegd. De vrijstelling geldt per schenker per jaar, niet per schenking.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading7">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse7" aria-expanded="false" aria-controls="collapse7">
                Relatie schenker en ontvanger
            </button>
        </h2>
        <div id="collapse7" class="accordion-collapse collapse" aria-labelledby="heading7"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                De hoogte van de vrijstelling en het tarief van de schenkbelasting hangen af van de relatie tussen
                schenker en ontvanger.
                <div class="space20"></div>

                Kinderen krijgen een hogere vrijstelling dan derden. Partners, ouders, kleinkinderen
                en anderen vallen onder verschillende categorieën, met elk eigen tarieven en vrijstellingen.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading9">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse9" aria-expanded="false" aria-controls="collapse9">
                Wie betaalt de schenkbelasting? (Schenking vrij van recht)
            </button>
        </h2>
        <div id="collapse9" class="accordion-collapse collapse" aria-labelledby="heading9"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Bij een schenking vrij van recht neemt de schenker de schenkbelasting voor zijn rekening. De
                Belastingdienst ziet dit als een verhoging van de schenking, waardoor de grondslag voor belastingheffing
                toeneemt. De uiteindelijke belasting wordt dus berekend over het bedrag inclusief de belasting die de
                schenker betaalt.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading8">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse8" aria-expanded="false" aria-controls="collapse8">
                Onherroepelijke schenking
            </button>
        </h2>
        <div id="collapse8" class="accordion-collapse collapse" aria-labelledby="heading8"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Een onherroepelijke schenking is een schenking waarbij de schenker zich NIET het recht voorbehoudt om de
                schenking later ongedaan te maken. <br/>Is er wel een herroepelijke schenking? Voor de schenkbelasting wordt
                dan pas geheven wanneer de schenking onherroepelijk is geworden. Tot dat moment telt het nog niet mee
                voor belastingheffing.
            </div>
        </div>
    </div>

</div>
